import React, { Fragment } from 'react';

export default function UploadStatus(props) {
  return (
    <Fragment>
      {props.uploading &&
        <div className="proof-of-payment-multiple-uploads uploading">
          <div>Uploading</div>
        </div>
      }
      {props.failed &&
        <div className="proof-of-payment-multiple-uploads uploading">
          <div className="pop-file-error">File Type does not match</div>
        </div>
      }
      {props.sizeStatus &&
        <div className="proof-of-payment-multiple-uploads uploading">
          <div className="pop-file-error">File Size does not match</div>
        </div>
      }
      {props.uploaded &&
        <div className="proof-of-payment-multiple-uploads upload-complete">
          <i className="icon-tick" />
          <div>Upload Complete</div>
        </div>
      }
    </Fragment>
  );
}
